
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/legal/terms-of-use/2024-04-24",
      function () {
        return require("private-next-pages/[locale]/legal/terms-of-use/2024-04-24.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/legal/terms-of-use/2024-04-24"])
      });
    }
  